var _path, _path2, _rect, _g, _g2, _rect2, _rect3, _rect4, _rect5, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDriveContent2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 160,
    viewBox: "0 0 176 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.7388 37.8594C72.7388 31.7842 77.6636 26.8594 83.7388 26.8594H163.512V144.504C163.512 150.58 158.587 155.504 152.512 155.504H72.7388V37.8594Z",
    fill: "#FFCF85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.102 26.8594H164.535C170.61 26.8594 175.535 31.7842 175.535 37.8594V70.5636C175.535 76.6387 170.61 81.5636 164.535 81.5636H158.102V26.8594Z",
    fill: "#FFCF85"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.3687,
    y: 47.8984,
    width: 59.5134,
    height: 16.2309,
    fill: "#FFF2DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2575_3459)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.8207,
    height: 132.948,
    rx: 4,
    transform: "matrix(0.996581 -0.0826228 0.0947985 0.995496 6.80615 20.7422)",
    fill: "#CBE6FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2575_3459)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 7.10938,
    width: 100.088,
    height: 132.713,
    rx: 4,
    fill: "#F4F4F4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4331,
    y: 74.9141,
    width: 65.2504,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4331,
    y: 87.2188,
    width: 65.2504,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4331,
    y: 99.5234,
    width: 65.2504,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4331,
    y: 111.836,
    width: 46.8893,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0518 97.5121C73.452 97.0217 74.2013 97.0217 74.6015 97.5121L77.3699 100.905C77.6179 101.209 78.0207 101.34 78.4 101.24L82.634 100.122C83.246 99.9605 83.8522 100.401 83.8877 101.033L84.133 105.405C84.155 105.797 84.404 106.139 84.7696 106.281L88.8521 107.866C89.4421 108.095 89.6737 108.807 89.3309 109.34L86.9595 113.021C86.7471 113.351 86.7471 113.774 86.9595 114.104L89.3309 117.785C89.6737 118.318 89.4421 119.03 88.8521 119.259L84.7697 120.844C84.404 120.986 84.155 121.328 84.133 121.72L83.8877 126.092C83.8522 126.724 83.246 127.165 82.634 127.003L78.4 125.885C78.0207 125.785 77.6179 125.916 77.3699 126.22L74.6015 129.613C74.2013 130.103 73.452 130.103 73.0518 129.613L70.2834 126.22C70.0354 125.916 69.6326 125.785 69.2534 125.885L65.0193 127.003C64.4073 127.165 63.8011 126.724 63.7656 126.092L63.5203 121.72C63.4983 121.328 63.2494 120.986 62.8837 120.844L58.8013 119.259C58.2112 119.03 57.9796 118.318 58.3224 117.785L60.6938 114.104C60.9063 113.774 60.9063 113.351 60.6938 113.021L58.3224 109.34C57.9796 108.807 58.2112 108.095 58.8013 107.866L62.8837 106.281C63.2494 106.139 63.4983 105.797 63.5203 105.405L63.7656 101.033C63.8011 100.401 64.4073 99.9605 65.0193 100.122L69.2534 101.24C69.6326 101.34 70.0354 101.209 70.2834 100.905L73.0518 97.5121Z",
    fill: "#4091F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7728 6.59142V18.4827C90.7418 20.2696 89.7137 23.8435 85.8488 23.8435C81.0178 23.8435 79.9521 19.4574 79.9521 18.4827C79.9521 17.7029 79.9521 9.80141 79.9521 5.41528C79.9521 3.27096 80.8365 1 84.0399 1C87.7561 1 87.849 4.66152 87.849 5.41528V10.0028",
    stroke: "#374969",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.958 10.0197V4.60938",
    stroke: "#374969",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3013 31.6V38.854H33.7673V35.786H32.8313V38.49H31.3233V31.834H32.8313V34.486H33.7673V31.6H35.3013ZM25.3173 34.07V32.796H27.3453V31.704H28.9573V32.796H30.9853V34.07H25.3173ZM25.6553 36.462C25.6683 35.253 26.7213 34.447 28.1513 34.46C29.6333 34.447 30.6863 35.253 30.6993 36.462C30.6863 37.658 29.6333 38.464 28.1513 38.464C26.7213 38.464 25.6683 37.658 25.6553 36.462ZM27.1113 36.462C27.1113 36.995 27.5403 37.32 28.1513 37.32C28.8013 37.32 29.2303 36.995 29.2173 36.462C29.2303 35.929 28.8013 35.604 28.1513 35.604C27.5403 35.604 27.1113 35.929 27.1113 36.462ZM27.3453 41.064C27.3453 39.738 28.8663 38.971 31.3493 38.958C33.8453 38.971 35.3533 39.738 35.3533 41.064C35.3533 42.403 33.8453 43.17 31.3493 43.17C28.8663 43.17 27.3453 42.403 27.3453 41.064ZM28.9833 41.064C28.9703 41.662 29.7893 41.948 31.3493 41.948C32.9223 41.948 33.7283 41.662 33.7413 41.064C33.7283 40.466 32.9223 40.18 31.3493 40.18C29.7893 40.18 28.9703 40.466 28.9833 41.064ZM46.3546 31.6V38.464H44.7426V35.734H42.9226V34.434H44.7426V31.6H46.3546ZM36.5266 37.19C38.4246 36.566 39.2956 35.058 39.3346 33.602H36.9946V32.302H43.2606V33.602H40.9726C40.9986 34.941 41.8306 36.306 43.6246 36.904L42.8186 38.178C41.5576 37.762 40.6736 36.93 40.1666 35.89C39.6596 37.073 38.7496 38.009 37.3846 38.49L36.5266 37.19ZM38.4246 40.96C38.4246 39.556 39.9326 38.737 42.4026 38.724C44.8726 38.737 46.3806 39.556 46.3806 40.96C46.3806 42.364 44.8726 43.183 42.4026 43.196C39.9326 43.183 38.4246 42.364 38.4246 40.96ZM40.0366 40.96C40.0366 41.623 40.8686 41.948 42.4026 41.948C43.9366 41.948 44.7686 41.623 44.7686 40.96C44.7686 40.297 43.9366 39.959 42.4026 39.972C40.8686 39.959 40.0366 40.297 40.0366 40.96ZM60.508 31.626V38.152H58.896V31.626H60.508ZM50.784 36.67C52.734 36.085 53.579 34.603 53.592 33.16V32.042H55.256V33.16C55.256 34.564 56.114 35.916 57.986 36.488L57.18 37.736C55.854 37.333 54.944 36.527 54.437 35.487C53.917 36.618 52.968 37.515 51.59 37.944L50.784 36.67ZM52.76 43.04V38.672H60.508V43.04H52.76ZM54.372 41.74H58.922V39.946H54.372V41.74ZM68.5454 32.588V33.862H67.6094V37.086C68.0774 37.047 68.5194 37.008 68.9614 36.956L69.0654 38.126C66.7514 38.529 64.1254 38.568 62.1754 38.568L62.0194 37.268L63.2674 37.255V33.862H62.3314V32.588H68.5454ZM63.7354 42.962V39.322H65.3734V41.662H71.6654V42.962H63.7354ZM64.8274 37.229L66.0494 37.177V33.862H64.8274V37.229ZM69.6114 40.128V31.626H71.2494V34.876H72.8094V36.228H71.2494V40.128H69.6114ZM36.229 49.38C38.062 49.38 39.427 50.563 39.427 52.214C39.427 53.878 38.062 55.061 36.229 55.048C34.409 55.061 33.018 53.878 33.031 52.214C33.018 50.563 34.409 49.38 36.229 49.38ZM32.537 56.53C34.604 56.517 37.464 56.491 39.921 56.14L40.051 57.31C37.49 57.817 34.747 57.83 32.719 57.83L32.537 56.53ZM34.643 52.214C34.63 53.137 35.319 53.657 36.229 53.67C37.152 53.657 37.854 53.137 37.867 52.214C37.854 51.317 37.152 50.784 36.229 50.784C35.319 50.784 34.63 51.317 34.643 52.214ZM40.597 60.196V48.6H42.209V60.196H40.597ZM53.4443 48.626V57.154H51.8583V54.736H49.2063V53.436H51.8583V52.136H49.3753C48.5563 53.904 46.8793 55.204 44.5523 55.906L43.8763 54.632C46.3333 53.865 47.8933 52.487 48.1663 50.784H44.5003V49.484H49.9343C49.9343 49.965 49.8823 50.42 49.7913 50.862H51.8583V48.626H53.4443ZM45.8523 59.962V56.296H47.4903V58.662H53.7563V59.962H45.8523ZM59.3237 51.226C59.3367 53.397 60.2077 55.516 62.1317 56.348L61.1437 57.648C59.8567 57.024 58.9987 55.867 58.5177 54.437C58.0237 55.958 57.1267 57.206 55.8137 57.856L54.7997 56.53C56.7757 55.633 57.6727 53.397 57.6857 51.226V49.51H59.3237V51.226ZM60.8317 53.54V52.24H63.1197V48.6H64.7057V60.196H63.1197V53.54H60.8317Z",
    fill: "#374969"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2575_3459",
    x: 7.16699,
    y: 12.8125,
    width: 118.361,
    height: 146.961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2575_3459"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2575_3459"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2575_3459",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2575_3459",
    x: 0,
    y: 7.10938,
    width: 108.087,
    height: 140.711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2575_3459"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2575_3459",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDriveContent2);
export default __webpack_public_path__ + "static/media/IcDriveContent2.15aeb89e0aba8173aa3525aaae191f9c.svg";
export { ForwardRef as ReactComponent };